import api from '@/api/api';
import { TId } from '@/features/common';

export async function finishOnboarding(params: {
  workspaceId: TId;
}): Promise<void> {
  await api.post(`workspaces/${params.workspaceId}/onboarding`);
}
